import { render, staticRenderFns } from "./ContaForm.vue?vue&type=template&id=fdece458&scoped=true"
import script from "./ContaForm.vue?vue&type=script&lang=js"
export * from "./ContaForm.vue?vue&type=script&lang=js"
import style0 from "./ContaForm.vue?vue&type=style&index=0&id=fdece458&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdece458",
  null
  
)

export default component.exports